<template>
  <div class="modal-level2-pagination">
    <div class="mlp-wrapper">
      <div>Tampilan Baris</div>
      <div class="mlp-rows-setting">
        <b-form-select
          v-model="perPage"
          :options="modes"
          class="row-setting-wrapper"
        ></b-form-select>
      </div>
      <div class="mlp-pagination-wrapper">
        <b-pagination
          aria-controls="isupplier-table"
          v-model="currentPage"
          :total-rows="totalItems"
          :per-page="perPage"
          align="fill"
          class="mlp-pagination"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      modes: [1, 5, 10, 15, 25],
    }
  },
  computed: {
    totalItems() {
      return this.$store.state.level1.spmTotalItems
    },
    perPage: {
      get: function() {
        return this.$store.state.level1.spmPerPage
      },
      set: function(newValue) {
        this.$store.dispatch('level1/setKinerjaKontrakPerPage', newValue)
      },
    },
    currentPage: {
      get: function() {
        return this.$store.state.level1.spmPage
      },
      set: function(newValue) {
        this.$store.dispatch('level1/setKinerjaKontrakPage', newValue)
      }
    }
  }
}
</script>